<template>
  <div v-if="showReportLink" class="form-view__footer-links">
    <template v-if="showReportLink">
      <a
        class="form-view__report-abuse"
        href="#"
        @click.prevent="$refs.reportAbuseModal.show()"
      >
        {{ $t('formViewFooterLinks.reportAbuse') }}
      </a>
      <ReportAbuseModal
        ref="reportAbuseModal"
        resource-type="database_view"
        :identifier="identifier"
        :request-config="requestConfig"
      ></ReportAbuseModal>
    </template>
  </div>
</template>

<script>
import ReportAbuseModal from '@baserow/modules/core/components/abuseReport/ReportAbuseModal'
import addPublicAuthTokenHeader from '@baserow/modules/database/utils/publicView'

export default {
  name: 'FormViewFooterLinks',
  components: { ReportAbuseModal },
  props: {
    /**
     * Retained for API compatibility with the form view's persisted
     * `show_logo` field, which several parents still pass down.
     *
     * It no longer renders anything here: upstream used it to gate a
     * "Powered by Baserow" badge, which this deployment does not show. The
     * field is still meaningful elsewhere -- `pages/form.vue` uses it to drop
     * the brand suffix from the page title -- so it is not removed.
     */
    showLogo: {
      type: Boolean,
      required: false,
      default: true,
    },
    showReportAbuse: {
      type: Boolean,
      required: false,
      default: false,
    },
    identifier: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    showReportLink() {
      return (
        this.showReportAbuse &&
        this.$store.getters['settings/get'].allow_reporting_abuse !== false
      )
    },
    requestConfig() {
      const publicAuthToken =
        this.$store.getters['page/view/public/getAuthToken']
      return publicAuthToken
        ? addPublicAuthTokenHeader({}, publicAuthToken)
        : {}
    },
  },
}
</script>
